import requestFormTitleComponent from './requestFormTitle.component';

let requestFormTitleModule = angular.module('vacations-absences.requestFormTitle', [])

.component('requestFormTitle', requestFormTitleComponent)

.name;

export default requestFormTitleModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRequest/requestForm/requestFormTitle/requestFormTitle.js